import { useEffect } from "react";
import { setAtRestCipher } from "@veto/storage";
import { decryptUtf8, encryptUtf8 } from "../vaultCrypto";
import { migrateLegacyStickers } from "../stickers/myStickers";

/** H2: seal contact keys + conversation previews under the unlocked vault key. */
export function useAtRestVaultCipher(vaultKeyB64: string | null): void {
  useEffect(() => {
    if (!vaultKeyB64) {
      setAtRestCipher(null);
      return;
    }
    setAtRestCipher({
      seal: (pt) => encryptUtf8(vaultKeyB64, pt),
      open: (ct) => decryptUtf8(vaultKeyB64, ct),
    });
    // Older builds kept imported stickers as plain data URLs in localStorage:
    // seal them into My stickers now that the vault key is available.
    void migrateLegacyStickers();
  }, [vaultKeyB64]);
}
